// @flow
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement,
  injectStripe,
} from 'react-stripe-elements';
import type { CreditCardType } from '../../../utils/types';

type Props = {
  card: CreditCardType,
  creditCardWasEdited: boolean,
  stripe: Object,
  onRef: (arg: Object | void) => void,
  handleCreditCardDataChange: (e: SyntheticInputEvent<HTMLInputElement>, field: string) => void,
  cancelCreditCardErrorFieldsHighlight: () => void,
};

class CreditCardForm extends React.Component<Props> {
  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  createStripeToken = (type: string, name: string) => this.props.stripe.createToken(type, name);

  render() {
    const { creditCardWasEdited, card: { last4 }, handleCreditCardDataChange } = this.props;
    const cardPlaceholder = creditCardWasEdited ? '' : `•••• •••• •••• ${last4}`;
    const expiryDatePlaceholder = creditCardWasEdited ? '' : '••••';
    const cvcPlaceholder = creditCardWasEdited ? '' : '•••';
    const zipPlaceholder = creditCardWasEdited ? '' : '•••••';

    return (
      <div className="profile-credit-card-form">
        <Row>
          <Col md={12}>
            <label className="str-number-2">
              <span className="title-label">Card Number</span>
              <CardNumberElement
                //$FlowFixMe
                onReady={ref => (this.cardNumberInput = ref)}
                onChange={e => handleCreditCardDataChange(e, 'number')}
                onBlur={this.props.cancelCreditCardErrorFieldsHighlight}
                placeholder={cardPlaceholder}
              />
            </label>
          </Col>
          <Col md={8}>
            <label className="str-date-2">
              <span className="title-label">Card Expiration Date</span>
              <CardExpiryElement
                //$FlowFixMe
                onReady={ref => (this.expiryDateInput = ref)}
                onChange={e => handleCreditCardDataChange(e, 'expiration_date')}
                placeholder={expiryDatePlaceholder}
                onBlur={this.props.cancelCreditCardErrorFieldsHighlight}
              />
            </label>
          </Col>
          <Col md={4}>
            <label className="str-cvv-2">
              <span className="title-label">CVC</span>
              <CardCVCElement
                //$FlowFixMe
                onReady={ref => (this.cvcInput = ref)}
                onChange={e => handleCreditCardDataChange(e, 'cvc')}
                placeholder={cvcPlaceholder}
                onBlur={this.props.cancelCreditCardErrorFieldsHighlight}
              />
            </label>
          </Col>
          <Col md={12}>
            <label className="str-zip-2">
              <span className="title-label">ZIP Code</span>
              <PostalCodeElement
                //$FlowFixMe
                onReady={ref => (this.zipcodeInput = ref)}
                onChange={e => handleCreditCardDataChange(e, 'zipcode')}
                placeholder={zipPlaceholder}
                onBlur={this.props.cancelCreditCardErrorFieldsHighlight}
              />
            </label>
          </Col>
        </Row>
      </div>
    );
  }
}

export default injectStripe(CreditCardForm);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Profile/CreditCardForm.js